export default __webpack_public_path__ + "static/media/image88.f8e587b7.jpg";